export enum GanttRecalculationMessages {
  SUCCESS = 'Wykres został przeliczony',
  GANTT_TIME_EXCEEDED = 'Zaplanowane zlecenie przekracza czas realizacji dostępny w jednej turze',
  UNKNOWN_ERROR = 'Błąd podczas przeliczania wykresu',
}
